import { render, staticRenderFns } from "./shaka.vue?vue&type=template&id=068e0adc&scoped=true&"
import script from "./shaka.vue?vue&type=script&lang=js&"
export * from "./shaka.vue?vue&type=script&lang=js&"
import style0 from "./shaka.vue?vue&type=style&index=0&id=068e0adc&scoped=scss&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068e0adc",
  null
  
)

export default component.exports